import { Box, Button, Drawer, IconButton, Typography, } from "@mui/material";
import EastIcon from '@mui/icons-material/East';
import { useCallback, useEffect, useState } from "react";
import { getUsersAllData } from "../../../../actions/usersAllData";
import { useDispatch } from "react-redux";
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';





const RecentlyViewedDrawer = ({ open, onClose, item }) => {
    // // hooks
    // const dispatch = useDispatch();

    // const [loading, setloading] = useState(true);
    // const [Data, setData] = useState([]);

    // // Api calls for get Order
    // const getData = useCallback(
    //     async (id, orders) => {
    //         const res = await dispatch(getUsersAllData(item?._id, ""));
    //         setData(res?.data?.data);

    //         setloading(false);
    //     },
    //     [dispatch]
    // );

    // useEffect(() => {
    //     getData()
    // }, [open, item?._id]);

    const orders = [
        { status: "Title", id: "View Date | View Time", image: "https://images.unsplash.com/photo-1580480055273-228ff5388ef8?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
        { status: "Title", id: "View Date | View Time", image: "https://images.unsplash.com/photo-1580480055273-228ff5388ef8?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
        { status: "Title", id: "View Date | View Time", image: "https://images.unsplash.com/photo-1580480055273-228ff5388ef8?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
        { status: "Title", id: "View Date | View Time", image: "https://images.unsplash.com/photo-1580480055273-228ff5388ef8?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
        { status: "Title", id: "View Date | View Time", image: "https://images.unsplash.com/photo-1580480055273-228ff5388ef8?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
        { status: "Title", id: "View Date | View Time", image: "https://images.unsplash.com/photo-1580480055273-228ff5388ef8?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
        { status: "Title", id: "View Date | View Time", image: "https://images.unsplash.com/photo-1580480055273-228ff5388ef8?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
        { status: "Title", id: "View Date | View Time", image: "https://images.unsplash.com/photo-1580480055273-228ff5388ef8?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
    ];

    return (
        <>
            <Drawer anchor="right"
                open={open}
                onClose={onClose}
                sx={{
                    "& .MuiDrawer-paper": {
                        top: "0px  !important",
                        backgroundColor: "#fafafa",
                        padding: "10px",
                    },
                    "& .css-i9fmh8-MuiBackdrop-root-MuiModal-backdrop": {
                        top: "0px !important"
                    }
                }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Box sx={{ display: "flex", flexDirection: "column", marginTop: 1, p: 1 }}>
                        <Typography
                            className="sofiaRegular"
                            color="#222020"
                            variant="body1"
                            fontWeight="bold"
                            sx={{ fontSize: "16px" }}
                        >
                            Recently Viewed | [based on account email]
                        </Typography>
                        <Typography
                            className="sofiaRegular"
                            variant="body2"
                            sx={{ fontSize: "14px", color: "#1b1919" }}
                        >
                            15 pages
                        </Typography>
                    </Box>
                    <IconButton sx={{ color: 'red', cursor: "pointer", backgroundColor: "transparent", "&:hover": { backgroundColor: "transparent" } }} onClick={onClose}>
                        <CancelRoundedIcon />
                    </IconButton>
                </Box>
                <Box sx={{ mt: 5 }}>
                    {orders.map((order, index) => (
                        <Box
                            key={index}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: "4px 10px",
                                backgroundColor: "#ffffff",
                                border: "1px solid #ececec",
                                borderRadius: "2px"
                                // boxShadow: "0px 1px 4px rgba(0,0,0,0.1)",
                            }}
                        >
                            {/* Image */}
                            <Box
                                component="img"
                                src={order.image}
                                alt={order.id}
                                sx={{
                                    width: 50,
                                    height: 50,
                                    borderRadius: 1,
                                    objectFit: "cover",
                                    border: "1px solid #E0E0E0",
                                }}
                            />
                            {/* Order Details */}
                            <Box sx={{ flex: 1, ml: 1, lineHeight: 0.9 }}>
                                <Typography
                                    className="sofiaRegular"
                                    sx={{ fontWeight: "bold", fontSize: 16, color: "#000" }}>
                                    {order.status}
                                </Typography>
                                <Typography
                                    className="sofiaRegular"
                                    sx={{ fontSize: 14, color: "#000", }}>
                                    {order.id}
                                </Typography>
                            </Box>
                            <EastIcon sx={{ fontSize: 16 }} />
                        </Box>
                    ))}
                </Box>
            </Drawer>
        </>
    )
}


export default RecentlyViewedDrawer